export default function formatDate(date: string): string {
    if (!date) {
        return "";
    }
    const localDate = new Date(date);
    const formattedDate = localDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    const formattedTime = localDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return `${formattedDate} ${formattedTime}`;
}